import React from 'react';

import {
  ResultsCardContainer,
  ResultsCardContent,
  ResultsText,
} from './styles';

const ResultsCardSkeleton: React.FC = () => {
  return (
    <ResultsCardContainer>
      <ResultsCardContent>
        <ResultsText />
        <ResultsText />
      </ResultsCardContent>
    </ResultsCardContainer>
  );
};

export default ResultsCardSkeleton;
